"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryClientImpl = exports.QueryAllPoolRouteAddressResponse_AddressesEntry = exports.QueryAllPoolRouteAddressResponse = exports.QueryAllPoolRouteAddressRequest = exports.QueryAllPoolRouteResponse = exports.QueryAllPoolRouteRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.QueryClaimableRewardsResponse = exports.QueryClaimableRewardsRequest = exports.QueryAllTotalCommitmentResponse = exports.QueryAllTotalCommitmentRequest = exports.QueryTotalCommitmentResponse = exports.QueryTotalCommitmentRequest = exports.QueryRewardCurveResponse = exports.QueryRewardCurveRequest = exports.QueryCommitmentCurveResponse = exports.QueryCommitmentCurveRequest = exports.QueryAllCommitmentResponse = exports.QueryAllCommitmentRequest = exports.QueryCommitmentResponse = exports.QueryCommitmentRequest = exports.ExtendedPool = exports.QueryAllPoolAddressResponse_AddressesEntry = exports.QueryAllPoolAddressResponse = exports.QueryAllPoolAddressRequest = exports.QueryAllPoolResponse = exports.QueryAllPoolRequest = exports.QueryGetPoolResponse = exports.QueryGetPoolRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const pagination_1 = require("../cosmos/base/query/v1beta1/pagination");
const liquiditypool_1 = require("./liquiditypool");
const reward_1 = require("./reward");
const timestamp_1 = require("../google/protobuf/timestamp");
const coin_1 = require("../cosmos/base/v1beta1/coin");
exports.protobufPackage = "Switcheo.carbon.liquiditypool";
const baseQueryGetPoolRequest = { id: long_1.default.UZERO };
exports.QueryGetPoolRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.id.isZero()) {
            writer.uint32(8).uint64(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetPoolRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetPoolRequest);
        message.id =
            object.id !== undefined && object.id !== null
                ? long_1.default.fromString(object.id)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined &&
            (obj.id = (message.id || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetPoolRequest);
        message.id =
            object.id !== undefined && object.id !== null
                ? long_1.default.fromValue(object.id)
                : long_1.default.UZERO;
        return message;
    },
};
const baseQueryGetPoolResponse = {};
exports.QueryGetPoolResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pool !== undefined) {
            exports.ExtendedPool.encode(message.pool, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetPoolResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pool = exports.ExtendedPool.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetPoolResponse);
        message.pool =
            object.pool !== undefined && object.pool !== null
                ? exports.ExtendedPool.fromJSON(object.pool)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pool !== undefined &&
            (obj.pool = message.pool ? exports.ExtendedPool.toJSON(message.pool) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetPoolResponse);
        message.pool =
            object.pool !== undefined && object.pool !== null
                ? exports.ExtendedPool.fromPartial(object.pool)
                : undefined;
        return message;
    },
};
const baseQueryAllPoolRequest = {};
exports.QueryAllPoolRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllPoolRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllPoolRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllPoolRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllPoolResponse = {};
exports.QueryAllPoolResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.pools) {
            exports.ExtendedPool.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllPoolResponse);
        message.pools = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pools.push(exports.ExtendedPool.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllPoolResponse);
        message.pools = ((_a = object.pools) !== null && _a !== void 0 ? _a : []).map((e) => exports.ExtendedPool.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.pools) {
            obj.pools = message.pools.map((e) => e ? exports.ExtendedPool.toJSON(e) : undefined);
        }
        else {
            obj.pools = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllPoolResponse);
        message.pools = ((_a = object.pools) !== null && _a !== void 0 ? _a : []).map((e) => exports.ExtendedPool.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllPoolAddressRequest = {};
exports.QueryAllPoolAddressRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllPoolAddressRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllPoolAddressRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllPoolAddressRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllPoolAddressResponse = {};
exports.QueryAllPoolAddressResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        Object.entries(message.addresses).forEach(([key, value]) => {
            exports.QueryAllPoolAddressResponse_AddressesEntry.encode({ key: key, value }, writer.uint32(10).fork()).ldelim();
        });
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllPoolAddressResponse);
        message.addresses = {};
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    const entry1 = exports.QueryAllPoolAddressResponse_AddressesEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.addresses[entry1.key] = entry1.value;
                    }
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllPoolAddressResponse);
        message.addresses = Object.entries((_a = object.addresses) !== null && _a !== void 0 ? _a : {}).reduce((acc, [key, value]) => {
            acc[key] = String(value);
            return acc;
        }, {});
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        obj.addresses = {};
        if (message.addresses) {
            Object.entries(message.addresses).forEach(([k, v]) => {
                obj.addresses[k] = v;
            });
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllPoolAddressResponse);
        message.addresses = Object.entries((_a = object.addresses) !== null && _a !== void 0 ? _a : {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = String(value);
            }
            return acc;
        }, {});
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllPoolAddressResponse_AddressesEntry = {
    key: "",
    value: "",
};
exports.QueryAllPoolAddressResponse_AddressesEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllPoolAddressResponse_AddressesEntry);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllPoolAddressResponse_AddressesEntry);
        message.key =
            object.key !== undefined && object.key !== null ? String(object.key) : "";
        message.value =
            object.value !== undefined && object.value !== null
                ? String(object.value)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseQueryAllPoolAddressResponse_AddressesEntry);
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseExtendedPool = { rewardsWeight: "", totalCommitment: "" };
exports.ExtendedPool = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pool !== undefined) {
            liquiditypool_1.Pool.encode(message.pool, writer.uint32(10).fork()).ldelim();
        }
        if (message.rewardsWeight !== "") {
            writer.uint32(18).string(message.rewardsWeight);
        }
        if (message.totalCommitment !== "") {
            writer.uint32(26).string(message.totalCommitment);
        }
        for (const v of message.rewardPerCommitmentShare) {
            coin_1.DecCoin.encode(v, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseExtendedPool);
        message.rewardPerCommitmentShare = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pool = liquiditypool_1.Pool.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.rewardsWeight = reader.string();
                    break;
                case 3:
                    message.totalCommitment = reader.string();
                    break;
                case 4:
                    message.rewardPerCommitmentShare.push(coin_1.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseExtendedPool);
        message.pool =
            object.pool !== undefined && object.pool !== null
                ? liquiditypool_1.Pool.fromJSON(object.pool)
                : undefined;
        message.rewardsWeight =
            object.rewardsWeight !== undefined && object.rewardsWeight !== null
                ? String(object.rewardsWeight)
                : "";
        message.totalCommitment =
            object.totalCommitment !== undefined && object.totalCommitment !== null
                ? String(object.totalCommitment)
                : "";
        message.rewardPerCommitmentShare = ((_a = object.rewardPerCommitmentShare) !== null && _a !== void 0 ? _a : []).map((e) => coin_1.DecCoin.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pool !== undefined &&
            (obj.pool = message.pool ? liquiditypool_1.Pool.toJSON(message.pool) : undefined);
        message.rewardsWeight !== undefined &&
            (obj.rewardsWeight = message.rewardsWeight);
        message.totalCommitment !== undefined &&
            (obj.totalCommitment = message.totalCommitment);
        if (message.rewardPerCommitmentShare) {
            obj.rewardPerCommitmentShare = message.rewardPerCommitmentShare.map((e) => e ? coin_1.DecCoin.toJSON(e) : undefined);
        }
        else {
            obj.rewardPerCommitmentShare = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseExtendedPool);
        message.pool =
            object.pool !== undefined && object.pool !== null
                ? liquiditypool_1.Pool.fromPartial(object.pool)
                : undefined;
        message.rewardsWeight = (_a = object.rewardsWeight) !== null && _a !== void 0 ? _a : "";
        message.totalCommitment = (_b = object.totalCommitment) !== null && _b !== void 0 ? _b : "";
        message.rewardPerCommitmentShare = ((_c = object.rewardPerCommitmentShare) !== null && _c !== void 0 ? _c : []).map((e) => coin_1.DecCoin.fromPartial(e));
        return message;
    },
};
const baseQueryCommitmentRequest = { poolId: "", address: "" };
exports.QueryCommitmentRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.poolId !== "") {
            writer.uint32(10).string(message.poolId);
        }
        if (message.address !== "") {
            writer.uint32(18).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryCommitmentRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.poolId = reader.string();
                    break;
                case 2:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryCommitmentRequest);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? String(object.poolId)
                : "";
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.poolId !== undefined && (obj.poolId = message.poolId);
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseQueryCommitmentRequest);
        message.poolId = (_a = object.poolId) !== null && _a !== void 0 ? _a : "";
        message.address = (_b = object.address) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseQueryCommitmentResponse = {};
exports.QueryCommitmentResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.commitment !== undefined) {
            reward_1.CommitmentResponse.encode(message.commitment, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryCommitmentResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.commitment = reward_1.CommitmentResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryCommitmentResponse);
        message.commitment =
            object.commitment !== undefined && object.commitment !== null
                ? reward_1.CommitmentResponse.fromJSON(object.commitment)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.commitment !== undefined &&
            (obj.commitment = message.commitment
                ? reward_1.CommitmentResponse.toJSON(message.commitment)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryCommitmentResponse);
        message.commitment =
            object.commitment !== undefined && object.commitment !== null
                ? reward_1.CommitmentResponse.fromPartial(object.commitment)
                : undefined;
        return message;
    },
};
const baseQueryAllCommitmentRequest = { address: "" };
exports.QueryAllCommitmentRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllCommitmentRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllCommitmentRequest);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllCommitmentRequest);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllCommitmentResponse = {};
exports.QueryAllCommitmentResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.commitments) {
            reward_1.Commitment.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        if (message.blockTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.blockTime), writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllCommitmentResponse);
        message.commitments = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.commitments.push(reward_1.Commitment.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.blockTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllCommitmentResponse);
        message.commitments = ((_a = object.commitments) !== null && _a !== void 0 ? _a : []).map((e) => reward_1.Commitment.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        message.blockTime =
            object.blockTime !== undefined && object.blockTime !== null
                ? fromJsonTimestamp(object.blockTime)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.commitments) {
            obj.commitments = message.commitments.map((e) => e ? reward_1.Commitment.toJSON(e) : undefined);
        }
        else {
            obj.commitments = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        message.blockTime !== undefined &&
            (obj.blockTime = message.blockTime.toISOString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseQueryAllCommitmentResponse);
        message.commitments = ((_a = object.commitments) !== null && _a !== void 0 ? _a : []).map((e) => reward_1.Commitment.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        message.blockTime = (_b = object.blockTime) !== null && _b !== void 0 ? _b : undefined;
        return message;
    },
};
const baseQueryCommitmentCurveRequest = {};
exports.QueryCommitmentCurveRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryCommitmentCurveRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryCommitmentCurveRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryCommitmentCurveRequest);
        return message;
    },
};
const baseQueryCommitmentCurveResponse = {};
exports.QueryCommitmentCurveResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.commitmentCurve !== undefined) {
            reward_1.CommitmentCurve.encode(message.commitmentCurve, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryCommitmentCurveResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.commitmentCurve = reward_1.CommitmentCurve.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryCommitmentCurveResponse);
        message.commitmentCurve =
            object.commitmentCurve !== undefined && object.commitmentCurve !== null
                ? reward_1.CommitmentCurve.fromJSON(object.commitmentCurve)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.commitmentCurve !== undefined &&
            (obj.commitmentCurve = message.commitmentCurve
                ? reward_1.CommitmentCurve.toJSON(message.commitmentCurve)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryCommitmentCurveResponse);
        message.commitmentCurve =
            object.commitmentCurve !== undefined && object.commitmentCurve !== null
                ? reward_1.CommitmentCurve.fromPartial(object.commitmentCurve)
                : undefined;
        return message;
    },
};
const baseQueryRewardCurveRequest = {};
exports.QueryRewardCurveRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryRewardCurveRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryRewardCurveRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryRewardCurveRequest);
        return message;
    },
};
const baseQueryRewardCurveResponse = {};
exports.QueryRewardCurveResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.rewardCurve !== undefined) {
            reward_1.RewardCurve.encode(message.rewardCurve, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryRewardCurveResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rewardCurve = reward_1.RewardCurve.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryRewardCurveResponse);
        message.rewardCurve =
            object.rewardCurve !== undefined && object.rewardCurve !== null
                ? reward_1.RewardCurve.fromJSON(object.rewardCurve)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.rewardCurve !== undefined &&
            (obj.rewardCurve = message.rewardCurve
                ? reward_1.RewardCurve.toJSON(message.rewardCurve)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryRewardCurveResponse);
        message.rewardCurve =
            object.rewardCurve !== undefined && object.rewardCurve !== null
                ? reward_1.RewardCurve.fromPartial(object.rewardCurve)
                : undefined;
        return message;
    },
};
const baseQueryTotalCommitmentRequest = { poolId: long_1.default.UZERO };
exports.QueryTotalCommitmentRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.poolId.isZero()) {
            writer.uint32(8).uint64(message.poolId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryTotalCommitmentRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.poolId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryTotalCommitmentRequest);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryTotalCommitmentRequest);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        return message;
    },
};
const baseQueryTotalCommitmentResponse = { totalCommitment: "" };
exports.QueryTotalCommitmentResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.totalCommitment !== "") {
            writer.uint32(10).string(message.totalCommitment);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryTotalCommitmentResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.totalCommitment = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryTotalCommitmentResponse);
        message.totalCommitment =
            object.totalCommitment !== undefined && object.totalCommitment !== null
                ? String(object.totalCommitment)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.totalCommitment !== undefined &&
            (obj.totalCommitment = message.totalCommitment);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryTotalCommitmentResponse);
        message.totalCommitment = (_a = object.totalCommitment) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryAllTotalCommitmentRequest = {};
exports.QueryAllTotalCommitmentRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllTotalCommitmentRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllTotalCommitmentRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllTotalCommitmentRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllTotalCommitmentResponse = {};
exports.QueryAllTotalCommitmentResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.totalCommitments) {
            reward_1.TotalCommitmentRecord.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllTotalCommitmentResponse);
        message.totalCommitments = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.totalCommitments.push(reward_1.TotalCommitmentRecord.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllTotalCommitmentResponse);
        message.totalCommitments = ((_a = object.totalCommitments) !== null && _a !== void 0 ? _a : []).map((e) => reward_1.TotalCommitmentRecord.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.totalCommitments) {
            obj.totalCommitments = message.totalCommitments.map((e) => e ? reward_1.TotalCommitmentRecord.toJSON(e) : undefined);
        }
        else {
            obj.totalCommitments = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllTotalCommitmentResponse);
        message.totalCommitments = ((_a = object.totalCommitments) !== null && _a !== void 0 ? _a : []).map((e) => reward_1.TotalCommitmentRecord.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryClaimableRewardsRequest = {
    poolId: long_1.default.UZERO,
    address: "",
};
exports.QueryClaimableRewardsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.poolId.isZero()) {
            writer.uint32(8).uint64(message.poolId);
        }
        if (message.address !== "") {
            writer.uint32(18).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryClaimableRewardsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.poolId = reader.uint64();
                    break;
                case 2:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryClaimableRewardsRequest);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryClaimableRewardsRequest);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryClaimableRewardsResponse = {};
exports.QueryClaimableRewardsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.rewards) {
            coin_1.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryClaimableRewardsResponse);
        message.rewards = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rewards.push(coin_1.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryClaimableRewardsResponse);
        message.rewards = ((_a = object.rewards) !== null && _a !== void 0 ? _a : []).map((e) => coin_1.DecCoin.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.rewards) {
            obj.rewards = message.rewards.map((e) => e ? coin_1.DecCoin.toJSON(e) : undefined);
        }
        else {
            obj.rewards = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryClaimableRewardsResponse);
        message.rewards = ((_a = object.rewards) !== null && _a !== void 0 ? _a : []).map((e) => coin_1.DecCoin.fromPartial(e));
        return message;
    },
};
const baseQueryParamsRequest = {};
exports.QueryParamsRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
};
const baseQueryParamsResponse = {};
exports.QueryParamsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.params !== undefined) {
            liquiditypool_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = liquiditypool_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        message.params =
            object.params !== undefined && object.params !== null
                ? liquiditypool_1.Params.fromJSON(object.params)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined &&
            (obj.params = message.params ? liquiditypool_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        message.params =
            object.params !== undefined && object.params !== null
                ? liquiditypool_1.Params.fromPartial(object.params)
                : undefined;
        return message;
    },
};
const baseQueryAllPoolRouteRequest = {};
exports.QueryAllPoolRouteRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllPoolRouteRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllPoolRouteRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllPoolRouteRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllPoolRouteResponse = {};
exports.QueryAllPoolRouteResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.poolRoutes) {
            liquiditypool_1.PoolRoute.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllPoolRouteResponse);
        message.poolRoutes = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.poolRoutes.push(liquiditypool_1.PoolRoute.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllPoolRouteResponse);
        message.poolRoutes = ((_a = object.poolRoutes) !== null && _a !== void 0 ? _a : []).map((e) => liquiditypool_1.PoolRoute.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.poolRoutes) {
            obj.poolRoutes = message.poolRoutes.map((e) => e ? liquiditypool_1.PoolRoute.toJSON(e) : undefined);
        }
        else {
            obj.poolRoutes = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllPoolRouteResponse);
        message.poolRoutes = ((_a = object.poolRoutes) !== null && _a !== void 0 ? _a : []).map((e) => liquiditypool_1.PoolRoute.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllPoolRouteAddressRequest = {};
exports.QueryAllPoolRouteAddressRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllPoolRouteAddressRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllPoolRouteAddressRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllPoolRouteAddressRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllPoolRouteAddressResponse = {};
exports.QueryAllPoolRouteAddressResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        Object.entries(message.addresses).forEach(([key, value]) => {
            exports.QueryAllPoolRouteAddressResponse_AddressesEntry.encode({ key: key, value }, writer.uint32(10).fork()).ldelim();
        });
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllPoolRouteAddressResponse);
        message.addresses = {};
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    const entry1 = exports.QueryAllPoolRouteAddressResponse_AddressesEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.addresses[entry1.key] = entry1.value;
                    }
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllPoolRouteAddressResponse);
        message.addresses = Object.entries((_a = object.addresses) !== null && _a !== void 0 ? _a : {}).reduce((acc, [key, value]) => {
            acc[key] = String(value);
            return acc;
        }, {});
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        obj.addresses = {};
        if (message.addresses) {
            Object.entries(message.addresses).forEach(([k, v]) => {
                obj.addresses[k] = v;
            });
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllPoolRouteAddressResponse);
        message.addresses = Object.entries((_a = object.addresses) !== null && _a !== void 0 ? _a : {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = String(value);
            }
            return acc;
        }, {});
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllPoolRouteAddressResponse_AddressesEntry = {
    key: "",
    value: "",
};
exports.QueryAllPoolRouteAddressResponse_AddressesEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllPoolRouteAddressResponse_AddressesEntry);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllPoolRouteAddressResponse_AddressesEntry);
        message.key =
            object.key !== undefined && object.key !== null ? String(object.key) : "";
        message.value =
            object.value !== undefined && object.value !== null
                ? String(object.value)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseQueryAllPoolRouteAddressResponse_AddressesEntry);
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.PoolAddressAll = this.PoolAddressAll.bind(this);
        this.Pool = this.Pool.bind(this);
        this.PoolAll = this.PoolAll.bind(this);
        this.Commitment = this.Commitment.bind(this);
        this.CommitmentAll = this.CommitmentAll.bind(this);
        this.CommitmentCurve = this.CommitmentCurve.bind(this);
        this.RewardCurve = this.RewardCurve.bind(this);
        this.TotalCommitment = this.TotalCommitment.bind(this);
        this.TotalCommitmentAll = this.TotalCommitmentAll.bind(this);
        this.ClaimableRewards = this.ClaimableRewards.bind(this);
        this.Params = this.Params.bind(this);
        this.PoolRouteAll = this.PoolRouteAll.bind(this);
        this.PoolRouteAddressAll = this.PoolRouteAddressAll.bind(this);
    }
    PoolAddressAll(request) {
        const data = exports.QueryAllPoolAddressRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquiditypool.Query", "PoolAddressAll", data);
        return promise.then((data) => exports.QueryAllPoolAddressResponse.decode(new minimal_1.default.Reader(data)));
    }
    Pool(request) {
        const data = exports.QueryGetPoolRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquiditypool.Query", "Pool", data);
        return promise.then((data) => exports.QueryGetPoolResponse.decode(new minimal_1.default.Reader(data)));
    }
    PoolAll(request) {
        const data = exports.QueryAllPoolRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquiditypool.Query", "PoolAll", data);
        return promise.then((data) => exports.QueryAllPoolResponse.decode(new minimal_1.default.Reader(data)));
    }
    Commitment(request) {
        const data = exports.QueryCommitmentRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquiditypool.Query", "Commitment", data);
        return promise.then((data) => exports.QueryCommitmentResponse.decode(new minimal_1.default.Reader(data)));
    }
    CommitmentAll(request) {
        const data = exports.QueryAllCommitmentRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquiditypool.Query", "CommitmentAll", data);
        return promise.then((data) => exports.QueryAllCommitmentResponse.decode(new minimal_1.default.Reader(data)));
    }
    CommitmentCurve(request) {
        const data = exports.QueryCommitmentCurveRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquiditypool.Query", "CommitmentCurve", data);
        return promise.then((data) => exports.QueryCommitmentCurveResponse.decode(new minimal_1.default.Reader(data)));
    }
    RewardCurve(request) {
        const data = exports.QueryRewardCurveRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquiditypool.Query", "RewardCurve", data);
        return promise.then((data) => exports.QueryRewardCurveResponse.decode(new minimal_1.default.Reader(data)));
    }
    TotalCommitment(request) {
        const data = exports.QueryTotalCommitmentRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquiditypool.Query", "TotalCommitment", data);
        return promise.then((data) => exports.QueryTotalCommitmentResponse.decode(new minimal_1.default.Reader(data)));
    }
    TotalCommitmentAll(request) {
        const data = exports.QueryAllTotalCommitmentRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquiditypool.Query", "TotalCommitmentAll", data);
        return promise.then((data) => exports.QueryAllTotalCommitmentResponse.decode(new minimal_1.default.Reader(data)));
    }
    ClaimableRewards(request) {
        const data = exports.QueryClaimableRewardsRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquiditypool.Query", "ClaimableRewards", data);
        return promise.then((data) => exports.QueryClaimableRewardsResponse.decode(new minimal_1.default.Reader(data)));
    }
    Params(request) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquiditypool.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
    PoolRouteAll(request) {
        const data = exports.QueryAllPoolRouteRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquiditypool.Query", "PoolRouteAll", data);
        return promise.then((data) => exports.QueryAllPoolRouteResponse.decode(new minimal_1.default.Reader(data)));
    }
    PoolRouteAddressAll(request) {
        const data = exports.QueryAllPoolRouteAddressRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquiditypool.Query", "PoolRouteAddressAll", data);
        return promise.then((data) => exports.QueryAllPoolRouteAddressResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
function toTimestamp(date) {
    const seconds = numberToLong(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new Date(o);
    }
    else {
        return fromTimestamp(timestamp_1.Timestamp.fromJSON(o));
    }
}
function numberToLong(number) {
    return long_1.default.fromNumber(number);
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
